module.exports = __webpack_public_path__ + "static/media/pic8.af6563a4.jpg";